import React from 'react'
import { render } from 'react-dom'
// import './index.css'
// import BrowserRouter from 'react-router-dom/BrowserRouter'
import App from './App'
// import registerServiceWorker from './registerServiceWorker'
import { ApolloClient } from 'apollo-client'
import { BatchHttpLink } from 'apollo-link-batch-http'
import { ApolloLink, Observable, from } from 'apollo-link'
import { notification, Button } from 'antd'
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory'
import { ApolloProvider } from 'react-apollo'
import { ApolloProvider as ApolloHooksProvider } from 'react-apollo-hooks'
// const liffId = process.env.REACT_APP_LINE_LIFF_ID
const liffId = '1655111748-Al7JBekk'
// const liffId = '1655111748-5nLrEkyy'
window.liff && window.liff.init({ liffId }, () => {}, err => console.error(err.code, err.message))
// import './index.css'
// const clientId = process.env.REACT_APP_CLIENT_ID
const clientId = window.location.hostname
const platform = process.env.REACT_APP_PLATFORM
// ponytail: global request timeout. BatchHttpLink never times out, so a dropped
// connection hangs the request forever = the endless spinner on EVERY page.
// AbortController turns a stalled request into a network error after 20s so Apollo
// sets `data.error` and pages can show a retry. Native, no new dependency.
const REQUEST_TIMEOUT_MS = 20000
const fetchWithTimeout = (input, init = {}) => {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS)
  return fetch(input, { ...init, signal: controller.signal })
    .finally(() => clearTimeout(timer))
}
// ponytail: global network-error toast. Hand-rolled link (no apollo-link-error
// dep) — catches NETWORK failures (incl. the AbortController timeout above) and
// pops ONE retry notification on any page. GraphQL business errors (SOLD_OUT etc.)
// arrive via `next`, not `error`, so they never trigger this. The error is still
// propagated, so per-page `data.error` handlers (e.g. EventRegister) still fire too.
let networkToastOpen = false
const notifyNetworkError = () => {
  if (networkToastOpen) return // one batch can error many ops — show one toast
  networkToastOpen = true
  notification.error({
    key: 'network-error',
    message: 'เชื่อมต่อไม่สำเร็จ',
    description: 'โหลดข้อมูลไม่ได้ กรุณาลองใหม่อีกครั้ง',
    duration: 0,
    onClose: () => { networkToastOpen = false },
    btn: (
      <Button type="primary" size="small" onClick={() => window.location.reload()}>
        โหลดใหม่
      </Button>
    )
  })
}
const errorLink = new ApolloLink((operation, forward) => {
  // A page that renders its own retry UI sets context { suppressErrorToast: true }
  // so it doesn't get the global toast on top of its inline button.
  const { suppressErrorToast } = operation.getContext()
  return new Observable(observer => {
    const sub = forward(operation).subscribe({
      next: value => observer.next(value),
      error: err => { if (!suppressErrorToast) notifyNetworkError(); observer.error(err) },
      complete: () => observer.complete()
    })
    return () => { if (sub) sub.unsubscribe() }
  })
})
const apolloClient = new ApolloClient({
  // initialState: window.__APOLLO_STATE__,
  // networkInterface
  link: from([errorLink, new BatchHttpLink({
    uri: process.env.REACT_APP_API_URI,
    credentials: 'include',
    fetch: fetchWithTimeout,
    headers: {
      ...(clientId && {'X-ThaiRun-Client-ID': clientId }),
      ...(platform && {
        'X-RunX-Platform': platform,
      })
    }
  })]),
  cache: new InMemoryCache({
    dataIdFromObject: object => {
      if (['PropertyQuestionItems', 'PropertyQuestionCondition'].includes(object.__typename)) {
        return null
      }
      if (['UserProfile', 'PropertyQuestion'].includes(object.__typename)) {
        return null
      }
      return defaultDataIdFromObject(object)
    }
  })
})
console.log('version', process.env.REACT_APP_WEBAPP_VERSION)
render(
  <ApolloProvider client={apolloClient}>
    <ApolloHooksProvider client={apolloClient}>
      <App />
    </ApolloHooksProvider>
  </ApolloProvider>,
  document.getElementById('root')
)

// registerServiceWorker()
